<template>
  <b-row>
    <b-col sm="3">
      <strong>Courses</strong>
      <p>Select the appropriate courses for this opportunity.</p>
    </b-col>
    <b-col sm="9">
      <b-form class="form-horizontal">
        <b-form-group v-for="academicPlan in academicPlans"
                      v-if="academicPlan.internshipCourses.length"
                      :key="academicPlan.academicPlanId"
                      :label="academicPlan.description"
                      label-class="control-label opportunity-form-label">
          <div v-for="course in academicPlan.internshipCourses"
               :key="course.internshipCourseId">
            <b-form-checkbox v-model="opportunityInternshipCourses"
                             :value="{internshipCourseId: course.internshipCourseId}">
              {{ course.displayName }}
            </b-form-checkbox>
          </div>
        </b-form-group>
        
        <slot name="buttons"></slot>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {};
  },

  props: {
    academicPlans: {
      type: Array,
      required: true
    },

    opportunity: {
      type: Object
    }
  },

  watch: {
    opportunity: function() {
      var oic = [];
      _.forEach(this.opportunity.opportunityInternshipCourses, function(
        opportunityInternshipCourse
      ) {
        oic.push({
          internshipCourseId: opportunityInternshipCourse.internshipCourseId
        });
      });
      this.opportunityInternshipCourses = oic;
    }
  },

  computed: {
    opportunityInternshipCourses: {
      get() {
        return this.$store.state.opportunityForm.opportunity
          .opportunityInternshipCourses;
      },
      set(value) {
        this.$store.commit("updateOpportunityInternshipCourses", value);
      }
    }
  }
};
</script>

<style scoped>
</style>
